import { GifDecision } from '@dreryk/egabinet-dashboard-frontend-api';

import { EmptyStatePlaceholder, LoaderSpinner } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../translations';

type GifDecisionsListElementRenderProps = {
   gifDecisions: GifDecision[];
};

type GifDecisionsCardListElementLoaderProps = {
   readonly gifDecisions: GifDecision[] | undefined;
   readonly gifDecisionsLoading: boolean;
   readonly gifDecisionsError: Error | null;
   readonly children: (renderProps: GifDecisionsListElementRenderProps) => JSX.Element;
};

export const GifDecisionsCardListElementLoader = (props: GifDecisionsCardListElementLoaderProps): JSX.Element => {
   const { gifDecisions, gifDecisionsLoading, gifDecisionsError, children } = props;

   if (gifDecisionsLoading) {
      return <LoaderSpinner />;
   }

   if (!gifDecisions || gifDecisions.length === 0 || gifDecisionsError) {
      return (
         <EmptyStatePlaceholder
            testId={'noGifDecisionsPlaceholder'}
            heading={dashboardTranslationKeys.cards.noDataFromGif}
         />
      );
   }

   return children({ gifDecisions: gifDecisions });
};
